// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-nav-mobile',
    // #endregion
    mixins: [host.mixins.modal],
    // #region Properties
    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        currentPage: {
            type: Object,
            required: false,
            default: {}
        },
        pages: {
            type: Array,
            required: false,
            default: []
        },
    },
    data: () => ({
        isOpen: true
    }),
    // #endregion
    // #region Constructor
    async beforeMount() {
        this.$host.eventBus.on('router-beforeLeave', this.onClose);
    },
    beforeUnmount() {
        this.$host.eventBus.off('router-beforeLeave', this.onClose);
    },
    // #endregion
    methods: {
        async onClose() {
            this.close(2);
        }
    },
});
// #endregion
